
import TrakkenButton from '~/components/ui/TrakkenButton.vue'
export default {
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: '#fff'
    },
    textColor: {
      type: String,
      required: false,
      default: 'inherit'
    }
  },
  components: {
    TrakkenButton
  },
  data() {
    return {
      story: { content: {} }
    }
  },
  /* beforeMount() {
    this.$store.dispatch('loadContact', 'draft')
  }, */
  computed: {
    buttonClass() {
      return this.textColor == 'inherit' ? 'btn-outline-primary' : 'btn-light'
    },
    contactUsStyle() {
      return {
        '--background-color': this.backgroundColor,
        '--color': this.textColor
      }
    }
    /* contactDetails() {
      //console.log(this.$store.state.contact)
      const contactDetails = this.$store.state.contact

      console.log('contact1', contactDetails.text[0].textline[0].text)
      console.log('contact2', contactDetails.text[0].textblock[0].text)
      console.log('contact3', contactDetails.button[0].text[0].text)
      return this.$store.state.contact
    } */
  }
}
